<template>
  <div class="tense-menu">
    <div class="dropdown">
      <button
        class="btn btn-info dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-bs-toggle="dropdown"
        data-bs-auto-close="outside" 
        aria-expanded="false"
      >
        <b>Tenses</b> <em>({{ selectedTenses.length }})</em>
      </button>
      <ul
        class="dropdown-menu"
        aria-labelledby="dropdownMenuButton"
      >
        <li
          v-for="(tense, key) in tenses"
          :key="key"
          class="dropdown-item d-flex justify-content-between align-items-center"
          @click="toggleTense(key)"
          :class="{ 'bg-info fw-bold': selectedTenses.includes(key) }"
        >
          <span class="me-2 d-inline-block">{{ tense }}</span>
          <span
            :class="{
              checked: selectedTenses.includes(key),
              unchecked: !selectedTenses.includes(key),
            }"
            class="circle"
          ></span>
        </li>
      </ul>
    </div>
  </div>
</template>
  
  <script>
import { mapGetters } from "vuex";
export default {
  name: "TenseMenu",
  computed: {
    ...mapGetters(["tenses", "selectedTenses"]), // Map Vuex getters to component computed properties
  },
  data() {
    return {};
  },
  methods: {
    toggleTense(tenseKey) {
      // Dispatch the Vuex action to toggle the tense in the state
      this.$store.dispatch("toggleTense", tenseKey);
    },
  },
};
</script>
  
  <style scoped>.tense-menu {
    text-align: right;
  }
  
  .dropdown-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }
  
  .circle {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid var(----bs-gray-400);
    display: inline-block;
    transition: all 0.3s ease;
  }
  
  /* Empty Circle */
  .unchecked {
    background-color: transparent;
  }
  
  /* Filled Circle */
  .checked {
    background-color: var(--bs-form-valid-color); /* Primary color */
  }
  
  /* Active class for bolding the selected tense */
  .active {
    font-weight: bold;
  }
</style>
  